import { Theme } from '@mui/material'
import { grey } from '@mui/material/colors'

import useSharedStyles from '../../utils/shared.styles'

const useStyles = {
  footer: (theme: Theme) => ({
    flexShrink: 0,
    padding: '16px 0',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
  }),
  footerButtonContainer: {
    width: '100%',
    justifyContent: 'space-between',
    paddingX: 2,
  },
  stickyBanner: {
    flexShrink: 0,
  },
  stickyHeader: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 1,
  }),
  contactsList: (isOnboarding: boolean) => ({
    ...(isOnboarding && {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      padding: '16px',
    }),
    ...(!isOnboarding && { mb: 7 }),
  }),
  fullBleedBanner: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      width: '100vw',
      marginLeft: 'calc(50% - 50vw)',
      marginRight: 'calc(50% - 50vw)',
      '&& .MuiAlert-message': {
        width: '97%',
        marginLeft: theme.spacing(2),
        marginRight: 'auto',
      },
      '&& .MuiGrid-container': {
        '--Grid-columnSpacing': theme.spacing(0.5),
      },
    },
  }),
  contactsDescription: {
    marginBottom: 2,
  },
  contactsListBox: {
    width: '100%',
  },
  contactCardContainer: (theme: Theme) => ({
    ...useSharedStyles.fullWidthContainer,
    padding: theme.spacing(2),
    minHeight: '72px',
    borderRadius: theme.spacing(2),
    margin: theme.spacing(0, 0, 2),
    alignItems: 'center',
    flexDirection: 'row',
  }),
  contactDetailsColumn: {
    flexDirection: 'column',
    gap: '6px',
    justifyContent: 'center',
    flex: '1',
  },
  contactName: {
    textAlign: 'left',
  },
  preferencesRow: {
    gap: '16px',
  },
  dragHandleContainer: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  youText: {
    color: grey[500],
  },
  contactFormContainer: (theme: Theme) => ({
    marginTop: theme.spacing(2),
    width: '100%',
  }),
  email: {
    maxWidth: '250px',
  },
  contactCardButtonBase: (theme: Theme) => ({
    width: '100%',
    zIndex: `${theme.zIndex.drawer} !important`, // Override the default 9999 zIndex that the library applies so that the full screen drawer can appear above an item that was recently dragged
  }),
  priorityAvatar: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
  }),
  contactsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontWeight: 500,
  },
  contactsHeaderRow: (hasOwnUserFolders: boolean, isMobile: boolean, isOnboarding: boolean) => ({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 2,
    paddingBottom: 1,
    marginTop: isMobile || isOnboarding ? (hasOwnUserFolders ? 0 : 2) : 0,
  }),
  preferenceIcon: {
    fontSize: '16px',
  },
}

export default useStyles
